import { gql } from "graphql-tag"

import { DEFAULTS } from "@/graphql/schemas/shared/utils/defaults"

const typeProducts = gql`
  type ProductCategory {
    id: String
    revId: ID
    title: String
    parentCategory: ProductCategory
    subCategories(sort: String = "sort"): [ProductCategory]
    sort: Int
    status: String
    collection: Boolean
    attachments: [AttachmentFile]
  }

  type AttachmentFile {
    language: String
    id: String
    asset: JSONObject
    type: String
    url: String
    fileName: String
  }

  type ProductCategories {
    limit: Int
    offset: Int
    count: Int
    total: Int

    items: [ProductCategory]

  }

  type ProductAttribute {
    id: ID!
    key: String
    value: String
  }

  type ShortProduct {
    key: String
    title: String
    shortDescription: String
    description: String
    descriptionBlocks: JSON
    categories: [ProductCategory]
    vendor: Vendor
    attachments: [AttachmentFile]

    priority: Int
    weighting: Float
    deleted: Boolean
    hidden: Boolean
    mix: Boolean
    sale: Boolean

    attributes: [ProductAttribute]
    variants: [ArticleRef]
    similarProducts: [ShortProduct]
    youtubeUrl: String

    images: [JSONObject]
  }

  type ShortProducts {
    limit: Int
    offset: Int
    count: Int
    total: Int

    items: [ShortProduct]
  }

  type AlgoliaProducts {
    count: Int
    items: [ShortProduct]
    total: Int
    totalPages: Int
    facets: [Facets]
    limit: Int
  }

  type Product {
    key: String
    modifiedAt: DateTime
    sysId: ID
    
    title: String
    shortDescription: String
    description: String
    descriptionBlocks: JSON
    youtubeUrl: String
    categories: [ProductCategory]
    vendor: Vendor
    attachments: [AttachmentFile]

    priority: Int
    weighting: Float
    deleted: Boolean
    hidden: Boolean
    mix: Boolean
    sale: Boolean

    similarProducts: [ShortProduct]

    attributes: [ProductAttribute]
    variants: [ArticleRef]

    images: [JSONObject]

    technicalManuals: [JSONObject]
    sdbManuals: [JSONObject]
    zertManuals: [JSONObject]
  }

  input ProductSearch {
    searchString: String
    searchInFields: IncludedProductFields
  }

  input IncludedProductFields {
    key: Boolean 
    title: Boolean
    shortDescription: Boolean

  }

  type Query {
    product(
      key: ID!
      customerId: ID = null
      lang: String = ""
      cdn: Boolean = true
      loggedInBranch: String
    ): Product

    products(
      offset: Int = ${DEFAULTS.QUERY.OFFSET}
      limit: Int = ${DEFAULTS.QUERY.LIMIT}
      sort: Sort
      vendor: String
      sortWithinLimits: Boolean = false
      categoryId: ID = null
      customerId: ID = null
      lang: String = ""
      cdn: Boolean = true
      loggedInBranch: String
    ): ShortProducts

    productSearch(
      offset: Int = ${DEFAULTS.QUERY.OFFSET}
      limit: Int = ${DEFAULTS.QUERY.LIMIT}
      sort: Sort = {
                orderBy: "title",
                direction: "desc"
            }
      sortWithinLimits: Boolean = false
      cdn: Boolean = true
      search: ProductSearch
      categories: [ID]
      vendor: ID
    ): ShortProducts

    algoliaProductSearch(
      searchTerm: String
      lang: String = ""
      cdn: Boolean = true
      loggedInBranch: String
      selectedFacets: [FacetsInput]
      page: Int = ${DEFAULTS.QUERY.PAGE}
      categoryId: String
      showAll: Boolean = false
    ): AlgoliaProducts

    productCategory(
      id: ID!
      lang: String = ""
      cdn: Boolean = true
    ): ProductCategory

    productCategories(
      offset: Int = ${DEFAULTS.QUERY.OFFSET}
      limit: Int = ${DEFAULTS.QUERY.LIMIT}
      mainOnly: Boolean = false
      sort: Sort
      sortWithinLimits: Boolean = false
      lang: String = ""
      cdn: Boolean = true
    ): ProductCategories

    algoliaProductFacets(categoryId: String): [Facets]
  }
`

export { typeProducts }

export default typeProducts
